import styled from '@emotion/styled';

import { spacing, borderRadius, typography } from '../tokens';

/**
 * Cores específicas do banner (Figma node 10187-55151).
 * Mantidas locais: divergem dos tokens semânticos globais.
 */
const CARD_BG = '#F2F2F2';
const BADGE_BG = '#E8EAFF';
const ACCENT = '#0B29FB';
const TITLE_COLOR = '#3D3D3D';
const BODY_COLOR = '#575757';
const DIVIDER_COLOR = '#D9D9D9';

// ─── Root ────────────────────────────────────────────────────────────────────

export const BannerRoot = styled('div')`
  display: flex;
  align-items: center;
  gap: ${spacing['2xl']};
  width: 100%;
  box-sizing: border-box;
  padding: ${spacing.xl} ${spacing['2xl']};
  background: ${CARD_BG};
  border-radius: ${borderRadius.xl};

  /* Empilha em telas estreitas: some o divisor e quebra a linha */
  @media (max-width: 720px) {
    flex-direction: column;
    align-items: stretch;
    gap: ${spacing.lg};
  }
`;

// ─── Bloco resumo (esquerda): badge + título + subtítulo ──────────────────────

export const SummaryBlock = styled('div')`
  display: flex;
  align-items: center;
  gap: ${spacing.md};
  flex-shrink: 0;
`;

export const IconBadge = styled('span')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: ${borderRadius.full};
  background: ${BADGE_BG};
  color: ${ACCENT};

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const SummaryText = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const Title = styled('span')`
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.lg};
  font-weight: ${typography.fontWeight.extraBold};
  line-height: 1.3;
  color: ${TITLE_COLOR};
`;

export const Subtitle = styled('span')`
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.md};
  font-weight: ${typography.fontWeight.regular};
  line-height: 1.3;
  color: ${TITLE_COLOR};
`;

// ─── Divisor vertical ─────────────────────────────────────────────────────────

export const Divider = styled('span')`
  align-self: stretch;
  width: 1px;
  min-width: 1px;
  background: ${DIVIDER_COLOR};
  margin: ${spacing.xs} 0;

  @media (max-width: 720px) {
    width: auto;
    height: 1px;
    min-width: 0;
    margin: 0;
  }
`;

// ─── Descrição (direita) ──────────────────────────────────────────────────────

export const Description = styled('p')`
  margin: 0;
  flex: 1;
  min-width: 0;
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.md};
  font-weight: ${typography.fontWeight.regular};
  line-height: 1.5;
  color: ${BODY_COLOR};

  strong,
  b {
    font-weight: ${typography.fontWeight.extraBold};
    color: ${TITLE_COLOR};
  }
`;
